module.exports = __webpack_public_path__ + "img/orange_094.24eaf581.png";